// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"folder-zip"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M2 3.5L9 3.5L11 6L22 6L22 20L2 20L2 3.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2 3.5H9L11 6H22V20H2V3.5Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M15 10H15.0039V10.0039H15V10Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M17 8H17.0039V8.00391H17V8Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M15 18H15.0039V18.0039H15V18Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M17 12H17.0039V12.0039H17V12Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M15 14H15.0039V14.0039H15V14Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M17 16H17.0039V16.0039H17V16Z","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-folder-zip')
export default class FolderZipIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-zip',
    }
  }
}
